
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Tempotravelleronrentinmumbai() {



    const cardData =
    {
        keyword: 'Tempo Traveller on Rent in Mumbai',
        heading: 'S9 Travels: Tempo Traveller on Rent in Mumbai',
        headingDescription: 'S9 Travels offers Tempo Traveller on Rent in Mumbai, providing a spacious, comfortable, and reliable travel experience for group trips, corporate travel, family outings, and more. Our well-maintained Tempo Travellers, available in various seating capacities, come with modern amenities and professional drivers to ensure a smooth and hassle-free journey. Enjoy affordable pricing, on-time service, and 24/7 availability for your travel needs. Book your Tempo Traveller on Rent in Mumbai with S9 Travels for a convenient and enjoyable ride!',


        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "One of Mumbai’s most iconic landmarks, the Gateway of India was built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this grand archway is a popular tourist spot, offering ferry rides to Elephanta Caves and stunning sunset views."
    },
    {
      "title": "Marine Drive",
      "description": "A picturesque boulevard along the Arabian Sea, Marine Drive is famous for its sweeping views, especially during sunset. Known as the ‘Queen’s Necklace’ due to its street lights resembling a string of pearls at night, it’s a favorite spot for locals and tourists to take a relaxing stroll."
    },
    {
      "title": "Elephanta Caves",
      "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island and house magnificent rock-cut temples dedicated to Lord Shiva. The main attraction is the large, intricately carved statue of Trimurti, depicting three aspects of Shiva."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus",
      "description": "Formerly known as Victoria Terminus, this UNESCO-listed railway station is an architectural marvel. Built in 1887, it showcases an exquisite blend of Victorian Gothic and Indian architectural styles, making it one of Mumbai’s most stunning heritage sites."
    },
    {
      "title": "Siddhivinayak Temple",
      "description": "One of the most revered temples in Mumbai, Siddhivinayak Temple is dedicated to Lord Ganesha. Devotees from all over the country visit this temple to seek blessings, making it a significant spiritual and cultural landmark."
    },
    {
      "title": "Colaba Causeway",
      "description": "A paradise for shopaholics, Colaba Causeway is a bustling street market offering everything from fashion accessories to antiques. The area is also home to famous cafes and restaurants, making it an ideal place for shopping and dining."
    },
    {
      "title": "Juhu Beach",
      "description": "One of Mumbai’s most popular beaches, Juhu Beach is known for its street food stalls serving Mumbai’s famous chaat, pav bhaji, and vada pav. Visitors can enjoy the scenic coastline, take a leisurely walk, or simply relax by the sea."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "Located on a small islet off the coast of Mumbai, Haji Ali Dargah is a stunning Indo-Islamic shrine dedicated to the Sufi saint Pir Haji Ali Shah Bukhari. Accessible via a narrow causeway, it is a place of deep spiritual significance and architectural beauty."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "An engineering marvel, the Bandra-Worli Sea Link connects the suburbs of Bandra and Worli, significantly reducing travel time. The bridge offers breathtaking views of Mumbai’s skyline, especially at night when it's beautifully illuminated."
    },
    {
      "title": "Kanheri Caves",
      "description": "Located within the Sanjay Gandhi National Park, the Kanheri Caves are a group of ancient Buddhist rock-cut caves dating back to the 1st century BCE. They feature intricate carvings, stupas, and meditation halls, offering a glimpse into India’s rich Buddhist heritage."
    }
],

"services": [
  {
    "name": "Tempo Traveller on Rent in Mumbai",
    "description": "Rent a spacious and comfortable Tempo Traveller in Mumbai with S9 Travels. Perfect for group trips, family outings, and more, our Tempo Travellers offer ample space and comfort for both short and long-distance journeys. Enjoy a smooth and reliable ride with professional chauffeurs ensuring a safe and enjoyable experience."
  },
  {
    "name": "Rent Tempo Traveller for Group Travel in Mumbai",
    "description": "Planning a group trip in Mumbai? Rent a Tempo Traveller with S9 Travels for a comfortable and spacious ride. Whether it's a family outing, corporate event, or friends' gathering, our Tempo Travellers provide plenty of room for everyone, ensuring a hassle-free and enjoyable travel experience."
  },
  {
    "name": "Affordable Tempo Traveller Rental in Mumbai",
    "description": "Looking for an affordable Tempo Traveller rental in Mumbai? S9 Travels offers budget-friendly rates without compromising on comfort or service quality. Our Tempo Travellers provide excellent value for money, ensuring you have a smooth and comfortable journey at competitive prices."
  },
  {
    "name": "Book Tempo Traveller for Mumbai Tours",
    "description": "Explore Mumbai in comfort with a Tempo Traveller rental from S9 Travels. Our spacious vehicles are perfect for sightseeing tours, offering a relaxed and enjoyable ride as you visit the city's top attractions. Let us take care of the driving while you enjoy your journey through Mumbai."
  },
  {
    "name": "Group Travel in Mumbai by Tempo Traveller",
    "description": "Traveling with a group in Mumbai? Choose a Tempo Traveller from S9 Travels for comfortable and spacious group travel. Whether you're visiting landmarks or attending events, our vehicles provide ample space and a smooth, enjoyable ride for all passengers."
  },
  {
    "name": "Tempo Traveller Hire for Weddings or Events in Mumbai",
    "description": "Make your special occasion unforgettable with a Tempo Traveller hire for weddings or events in Mumbai. Our luxury Tempo Travellers offer comfortable seating and premium amenities for your guests, ensuring they travel in style and comfort while you focus on celebrating the big day."
  },
  {
    "name": "Luxury Tempo Traveller Hire in Mumbai",
    "description": "Travel in luxury with a Tempo Traveller hire in Mumbai from S9 Travels. Our luxury Tempo Travellers are equipped with modern amenities and comfortable seating, offering a premium travel experience for group outings, corporate events, or leisure trips. Enjoy the highest level of comfort and style."
  },
  {
    "name": "Tempo Traveller for Outstation Trips from Mumbai",
    "description": "Going on an outstation trip from Mumbai? Rent a Tempo Traveller from S9 Travels for a comfortable and spacious ride to your destination. Whether you're planning a family vacation or a corporate trip, our Tempo Travellers offer a reliable and enjoyable journey for both short and long-distance travel."
  },
  {
    "name": "Comfortable Group Travel with Tempo Traveller in Mumbai",
    "description": "Enjoy comfortable group travel in Mumbai with a Tempo Traveller from S9 Travels. Our well-maintained vehicles provide ample space, air-conditioned comfort, and a smooth ride, making them ideal for group tours, family outings, and corporate travel across the city."
  }
],

"tableData": [
  ["Tempo Traveller on Rent in Mumbai", "Rent Tempo Traveller for Group Travel in Mumbai"],
  ["Affordable Tempo Traveller Rental in Mumbai", "Book Tempo Traveller for Mumbai Tours"],
  ["Group Travel in Mumbai by Tempo Traveller", "Tempo Traveller Hire for Weddings or Events in Mumbai"],
  ["Luxury Tempo Traveller Hire in Mumbai", "Tempo Traveller for Outstation Trips from Mumbai"],
  ["Comfortable Group Travel with Tempo Traveller in Mumbai", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spacious Ride",
    "WhyChoosedescription": "S9 Travels offers Tempo Traveller on rent in Mumbai, ensuring a comfortable and spacious ride for group travel. With seating options ranging from 9 to 17 seats, it’s the perfect choice for family outings, corporate trips, or city tours."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand the importance of punctuality. Our Tempo Traveller rental service in Mumbai guarantees timely pick-ups and drop-offs, ensuring you reach your destination on time, whether for business, leisure, or any special event."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are knowledgeable about the best routes and road conditions in Mumbai. They ensure that your journey is safe, smooth, and efficient, giving you a relaxed travel experience in the Tempo Traveller."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for Tempo Traveller rentals in Mumbai. We provide a transparent pricing structure with no hidden charges, making it easy to plan your travel budget."
  },
  {
    "WhyChooseheading": "Safety and Comfort During Your Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our Tempo Traveller vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your group."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Tempo Traveller rental in Mumbai. Whether you need a ride early in the morning or a late-night return, we’re here to accommodate your travel needs."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way or have specific locations to visit, we offer customizable itineraries to suit your preferences, ensuring your journey is as enjoyable as possible."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Tempo Traveller rental in Mumbai with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or reach out to our customer service team for personalized assistance."
  }
]















    }

    const faqData = [
        [
          {
            question: 'How can I rent a Tempo Traveller in Mumbai?',
            answer: 'Renting a Tempo Traveller in Mumbai is easy! You can book your rental through our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure a smooth and hassle-free rental experience.',
          },
          {
            question: 'What types of Tempo Traveller vehicles are available for rent in Mumbai?',
            answer: 'We offer various Tempo Traveller options for rent in Mumbai, including 12-seater, 15-seater, and 20-seater vehicles. Choose the one that best fits your group size and travel needs.',
          },
          {
            question: 'How long can I rent a Tempo Traveller in Mumbai?',
            answer: 'You can rent a Tempo Traveller in Mumbai for as long as you need! Whether it’s a few hours, a day, or longer, we provide flexible rental options to meet your schedule and travel requirements.',
          },
          {
            question: 'Do you provide drivers with the Tempo Traveller rental in Mumbai?',
            answer: 'Yes, we provide experienced and professional drivers with all Tempo Traveller rentals in Mumbai. Our drivers know the city routes and will ensure a comfortable and safe journey for you and your group.',
          },
          {
            question: 'How much does it cost to rent a Tempo Traveller in Mumbai?',
            answer: 'The cost of renting a Tempo Traveller depends on the model you choose, the duration of your rental, and any additional services. Contact us for a customized quote based on your needs.',
          },
          {
            question: 'Is there a security deposit required to rent a Tempo Traveller in Mumbai?',
            answer: 'Yes, a refundable security deposit is required when renting a Tempo Traveller. The amount of the deposit varies depending on the vehicle and rental duration.',
          },
          {
            question: 'Can I pick up the Tempo Traveller from a specific location in Mumbai?',
            answer: 'Yes, we offer flexible pick-up options. You can pick up your rented Tempo Traveller from a location of your choice in Mumbai, including your home, office, or any other convenient spot.',
          },
          {
            question: 'Can I extend my Tempo Traveller rental if I need more time?',
            answer: 'Yes, you can extend your Tempo Traveller rental in Mumbai based on availability. Just contact our customer service team, and they will assist you with the extension process.',
          },
          {
            question: 'Do you offer delivery and pick-up services for Tempo Traveller rentals in Mumbai?',
            answer: 'Yes, we offer delivery and pick-up services for your Tempo Traveller rental. We will make sure that the vehicle is delivered to your location and picked up at the end of your rental period.',
          },
          {
            question: 'Why should I choose S9 Travels for renting a Tempo Traveller in Mumbai?',
            answer: 'S9 Travels offers reliable, affordable, and comfortable Tempo Traveller rentals in Mumbai. With well-maintained vehicles, professional drivers, and excellent customer service, we ensure a seamless rental experience.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I rented a Tempo Traveller from S9 Travels for a family trip in Mumbai, and it was an excellent experience. The vehicle was spacious, comfortable, and in great condition. The driver was courteous, professional, and ensured a smooth ride. Highly recommended for group travel in Mumbai!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We rented a Tempo Traveller for a family outing in Mumbai, and it was fantastic. The vehicle was clean, well-maintained, and perfect for our large group. The driver was experienced, friendly, and knew all the best routes. We had an amazing experience, and I will definitely rent again from S9 Travels!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Tempo Traveller on Rent in Mumbai",
        "description": "Book affordable and luxury Tempo Traveller rental services in Mumbai for group travel, weddings, events, tours, and outstation trips. S9 Travels offers comfortable and reliable Tempo Traveller rentals for all your transportation needs in Mumbai.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      


    return (
        <div>
         <Helmet>
        <title>Tempo Traveller on Rent in Mumbai | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Tempo Traveller on rent in Mumbai for group travel, weddings, events, tours, and outstation trips. Affordable, luxury Tempo Traveller rental services for comfortable and reliable transportation in Mumbai with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/74.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Tempotravelleronrentinmumbai;